var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height ",attrs:{"id":"app"}},[_c('pg-navbar'),_c('router-view',{key:_vm.$route.fullPath,staticClass:"view-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }